import { Link } from "@tanstack/react-router";
import { DropdownMenu as DropdownMenuRadix } from "radix-ui";

import { useLogout } from "$/api/logout";
import PowerIcon from "$/lib/icons/PowerIcon";
import { useAuth } from "$/lib/providers/AuthProvider";
import { ROUTES } from "$/lib/utils/constants/routes.constants";
import { cn } from "$/lib/utils/functions/misc.functions";

import Button from "../../atoms/Button/Button";

export default function NavbarSettingsDropdownMenu() {
  const { user } = useAuth();

  if (!user) return null;

  // get first letter of first name and last name
  const initials = (
    user.firstName.charAt(0) + user.lastName.charAt(0)
  ).toUpperCase();

  return (
    <div className="flex flex-col items-center gap-1 rounded-lg">
      <div className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-secondary-300 bg-white text-xl font-bold tracking-widest text-secondary-300">
        {initials}
      </div>
      <div className="flex flex-col gap-3">
        <p className="text-center text-base font-bold">
          {user.firstName + " " + user.lastName}
        </p>
        <div className="flex flex-col gap-3">
          <DropdownMenuRadix.Item className="!focus:outline-none !data-[highlighted]:bg-transparent !bg-transparent !outline-none">
            <div className="flex flex-col gap-3">
              <Link
                to={ROUTES.USER_INFO}
                className="ml-2 rounded-lg text-base font-medium text-textColor hover:opacity-75"
              >
                Mon compte
              </Link>
              <Link
                to={ROUTES.SUBSCRIPTION}
                className="ml-2 rounded-lg text-base font-medium text-textColor hover:opacity-75"
              >
                Mon abonnement
              </Link>
            </div>
          </DropdownMenuRadix.Item>
          <DropdownMenuRadix.Item className="relative outline-none focus:outline-none data-[highlighted]:bg-transparent data-[highlighted]:outline-none">
            <LogoutButton />
          </DropdownMenuRadix.Item>
        </div>
      </div>
    </div>
  );
}

export function LogoutButton({
  className,
  iconClassName,
}: {
  className?: string;
  iconClassName?: string;
}) {
  const { mutate, isPending } = useLogout();
  const logout = async () => {
    mutate();
  };

  return (
    <Button
      onClick={logout}
      disabled={isPending}
      className={cn(
        "m-0 flex flex-row bg-primary px-3 py-1.5 text-left text-base font-medium text-white hover:opacity-80 hover:shadow-sm",
        className,
      )}
    >
      Se déconnecter
      <PowerIcon className={cn("size-3.5", iconClassName)} />
    </Button>
  );
}
